<template>
  <div style="flex: 1; padding: 10px">
    <el-row>
      <el-col :span="24">
        <h2 style="float: left; margin-left: 15px">Stok </h2>
      </el-col>
      </el-row>
    <el-tabs v-model="activeName" @tab-click="handleClick">
    <el-tab-pane   label="Sarf Malzeme" name="sarf-malzeme">
    <el-row>
     <el-col :span="24">
        <el-button style="float: right; margin-right: 30px"  @click="createStockItemDialog = true"
        >Stok kalemi yarat</el-button>
       <el-button style="float: left; margin-right: 30px" @click="addRemoveStock.showDialog = true"
        >Stok Ekle/Çıkar</el-button>
      </el-col>
    </el-row>
    
      <br>
    <el-card>
      <el-row>
        <el-col :span="20">
          <el-form
            :inline="true"
            :model="query"
            :label-position="'top'"
            class="demo-form-inline"
          >
            <el-col>
              <el-form-item label="Name" prop="name">
                <el-input
                style="width:150px; margin-right:10px"
                  @keyup.enter.native="filter()"
                  v-model="query.name"
                  clearable
                ></el-input>
                  <el-button type="primary" @click="filter()">Filter</el-button        >
              </el-form-item>
            </el-col>
          </el-form>
          <br />
        
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-table
            :row-class-name="tableRowClassName"
            v-loading="loading"
            :data="stocks"
            class="border"
          >
            <el-table-column prop="name" label="name">
            <template slot-scope="scope">
            {{scope.row.name}} 
            </template>
            </el-table-column>
            <el-table-column prop="quantity" label="quantity">
            <template slot-scope="scope">
            {{scope.row.quantity}} {{scope.row.unit}}
            </template>
            </el-table-column>
       
             <el-table-column prop="History" label="History">
             <template slot-scope="scope">
             
            <el-button   @click="showHistory(scope.row)"   size="mini" type="default" class="edit-quantity-button"> Geçmiş
             </el-button>
             </template>
             </el-table-column>
                  <el-table-column prop="minQuantity" label="Min Quantity" width="150px">
             <template slot-scope="scope">
             {{scope.row.minQuantity}} 
             <el-button @click="openEditMinQuantityDialog(scope.row)" size="mini" type="default" class="edit-quantity-button" icon="el-icon-edit">
             </el-button>

             </template>
             </el-table-column>
              <el-table-column prop="" label="Actions" width="150px">
             <template slot-scope="scope">
             <el-button @click="Delete(scope.row._id)" size="mini" type="default" class="edit-quantity-button" icon="el-icon-delete">
             </el-button>

             </template>
             </el-table-column>
          </el-table>
        </el-col>
      </el-row>
    </el-card>
</el-tab-pane>
    <el-tab-pane label="Cihazlar" name="cihazlar">
     <el-row>
        <el-col :span="24">
          <el-table
            v-loading="loading"
            :data="stockDevices"
            :row-class-name="tableRowClassName"
            class="border"
          >
            <el-table-column prop="name" label="name">
            <template slot-scope="scope">
            {{scope.row.name}} 
            </template>
            </el-table-column>
            <el-table-column prop="quantity" label="quantity">
            <template slot-scope="scope">
            <el-popover placement="left-end" width="500"  trigger="hover" class="devicePopOver">
                  
                  <el-table
height="250"
    style="width: 100%"
                  :data="scope.row.devices"
                  >
                  <el-table-column prop="macAddress" label="macAddress">
                    </el-table-column>
                  </el-table>
                  <i  slot="reference">
                   {{scope.row.quantity}} piece
                   </i>

                </el-popover>
            </template>
            </el-table-column>
     
          </el-table>
        </el-col>
      </el-row>
    </el-tab-pane>
  </el-tabs>
    <el-dialog width="30%" :title="'Create Stock Item'" :visible.sync="createStockItemDialog">
      <el-form
        ref="form"
        :model="form"
        :rules="rules"
        v-loading="formLoading"
        label-width="100px"
      >
        <el-form-item label="Product" prop="name">
          <el-input  v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item label="Unit" prop="unit">
          <el-select
            v-model="form.unit"
            placeholder="Select"
            allow-create
            :default-first-option="true"
          >
            <el-option
              v-for="item in unitOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button  type="primary" @click="CreateStock()"
            >Stok Kalemi Yarat</el-button
          >
            </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog width="30%" :title="minQuantityEdit.title" :visible.sync="minQuantityEdit.showDialog">
    <el-form
        ref="minQuantityEditForm"
        :model="minQuantityEdit"
        :rules="minQuantityEdit.rules"
    >
    <el-form-item label="minQuantity" prop="value">
      <el-input  v-model="minQuantityEdit.value"></el-input>
    </el-form-item>
    
     <el-form-item >
      <el-button  type="primary" @click="saveMinQuantityForm()" >Kaydet</el-button
          >
    </el-form-item>
    </el-form>
    </el-dialog>
      <el-dialog width="30%" :title="'Stok ekle/çıkar'" :visible.sync="addRemoveStock.showDialog">
    <el-form
        ref="addRemoveStockForm"
        :model="addRemoveStock"
        :rules="addRemoveStock.rules"
    >
      <el-form-item label="Stock" prop="stock">
          <el-select
            value-key="name"
            v-model="addRemoveStock.stock"
            placeholder="Select"
            :default-first-option="true"
            
          >
            <el-option
              v-for="item in stockSelect"
              :key="item.name"
              :label="item.name"
              :value="item"
            >
            </el-option>
          </el-select>
        </el-form-item>
    <el-form-item label="amount" prop="value">
      <el-input style="width:50%" v-model="addRemoveStock.amount" placeholder="-5 "></el-input> {{addRemoveStock.stock.unit}}
    </el-form-item>
    
     <el-form-item >
      <el-button  type="primary" @click="Update()" >Kaydet</el-button
          >
    </el-form-item>
    </el-form>
    </el-dialog>
     <el-dialog
      width="80%"
      :title="stockHistory.title"
      :visible.sync="stockHistory.showDialog"
    >
      <Plotly
        :data="stockHistory.data"
        :layout="stockHistory.layout"
        :display-mode-bar="false"
      ></Plotly>
    </el-dialog>
  </div>
</template>



<script>
import { mapState, mapActions } from "vuex";
import { Plotly } from "vue-plotly";
import moment from "moment";
import beautify from "json-beautify";
export default {
  name: "stock",
   components: { Plotly },
  data() {
    return {
      formLoading: false,
      showForm: false,
      activeName:'sarf-malzeme',
      addRemoveStock:{
        stock:'',
        amount:0,
        showDialog:false,
         rules:{
          "amount": [
          { required: true, message: "Please input amount", trigger: "blur" },
        ]
         }
      },
      minQuantityEdit:{
        stockItem:'',
        title:'',
        value:'',
        showDialog:false,
        rules:{
          "value": [
          { required: true, message: "Please input value", trigger: "blur" },
        ],
        }
      },
      stockHistory:{
        title:'',
        showDialog:false,
        data:[],
        layout:{
        margin: {
          r: 50,
          b: 100,
          t: 100,
          pad: 4,
        },
        }
      },
      createStockItemDialog:false,
      editStockDialog:false,
      query: {
        name: "",
      },
      unitOptions: [
        {
          value: "piece",
          label: "piece",
        },
        {
          value: "meter",
          label: "meter",
        },
      ],
      form: {
        name: "",
        quantity: 0,
        unit: "",
      },
      rules: {
        name: [
          { required: true, message: "Please input type", trigger: "blur" },
        ],
        quantity: [
          { required: true, message: "Please input quantity", trigger: "blur" },
        ],
        unit: [
          {
            required: true,
            message: "Please input unit",
            trigger: "blur",
          },
        ],
      },
    };
  },
  created() {
     this.getStocks(this.query)
  },
  computed: {
    ...mapState("stock", ["stocks", "stockConfigurations", "loading","stockDevices"]),
    stockSelect(){
      return this.stocks.filter(x=>!x.macAddresses);
    },
    total() {
      if (this.arrowDirection == "up") {
        return this.form.quantity + this.arrowDirectionNumber;
      } else {
        return this.form.quantity - this.arrowDirectionNumber;
      }
    },
  },
  methods: {
    
    showHistory(stock){
      this.stockHistory.title= "History of " +stock.name;
         this.stockHistory.data = [
            {
              x: stock.transactions.map(x=>moment(x.createdAt).toDate()),
              y: stock.transactions.map(x=>x.amount),
              mode: "lines+markers",
              type: "scatter",
            },
          ];
          this.stockHistory.showDialog = true;
    },
    openEditMinQuantityDialog(stock){
      this.minQuantityEdit.stock = stock;
      this.minQuantityEdit.value = stock.minQuantity;
      this.minQuantityEdit.title = "Edit min quantity of " + stock.name
      this.minQuantityEdit.showDialog=true
    },
    ...mapActions("stock", [
      "saveMinQuantity",
      "getStocks",
      "createStock",
      "updateStock",
      "deleteStock",
      "getStockDevices"
    ]),
    tableRowClassName({ row }) {
      if(!row.minQuantity && row.quantity < 10){
 return "redBackGround";
      }
      if (row.quantity < row.minQuantity) {
        return "redBackGround";
      }
      return "";
    },
    handleClick() {
      if(this.activeName == 'sarf-malzeme'){
        this.getStocks()
      }else{
        this.getStockDevices()
      }
    },
    filter() {
      this.getStocks(this.query);
    },
    infoJson(row) {
      return `${beautify(row, null, 5)}`;
    },
    saveMinQuantityForm(){
      this.$refs.minQuantityEditForm.validate((valid) => {
        console.log(valid)
        if (valid) {
          this.formLoading = true;
          this.saveMinQuantity({id:this.minQuantityEdit.stock._id, value:this.minQuantityEdit.value})
            .then(() => {
              this.formLoading = false;
              this.minQuantityEdit.showDialog = false;
              this.getStocks();
            })
            .finally(() => (this.formLoading = false));
        }
      });
    },
    CreateStock() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.formLoading = true;
          this.createStock(this.form)
            .then(() => {
              this.formLoading = false;
              this.createStockItemDialog = false;
              this.getStocks();
            })
            .finally(() => (this.formLoading = false));
        }
      });
    },
    Delete(id) {
      this.$confirm(
        "This will permanently delete the stock. Continue?",
        "Warning",
        {
          confirmButtonText: "OK",
          cancelButtonText: "Cancel",
          type: "warning",
        }
      )
        .then(() => this.deleteStock(id))
        .catch((e) => {
          this.$message({
            type: "info",
            message: e,
          });
        });
    },
    Update() {
      this.$refs.addRemoveStockForm.validate((valid) => {
        if (valid) {

          this.updateStock({_id:this.addRemoveStock.stock._id,amount:this.addRemoveStock.amount})
            .then(() => {
              this.addRemoveStock.showDialog = false;
            })
            .finally(() => (this.formLoading = false));
        }
      });
    },
    Create() {
      this.form.name = "";
      this.form.quantity = 0;
      this.form.unit = "";
      this.editId = undefined;
      this.showForm = true;
    },
    goBack() {
      this.$router.go(-1);
    },
  },
};
</script>
<style>
.devicePopOver{
  max-height:300px
}
.redBackGround {
  background: #e98a8c !important;
}
.edit-quantity-button{
  display:none
}
.el-table__row:hover .edit-quantity-button{
  display:inline-block
}
</style>
<style scoped>
.container {
  padding: 20px;
  margin-top: 0px;
  flex: 1;
  display: flex;
}
.tree-container {
  flex-basis: 20%;
  border: 1.5px solid #e4e7ed;
  margin-right: 10px;
}
.tabs {
  flex-basis: 80%;
  display: flex;
}
</style>